import React, { useState } from 'react';
import { Input, Form, Button, Popover, Tooltip } from 'antd';
import { USER_FEEDBACK } from '@src/utils/sensor/track';
import Icon from '@ant-design/icons';
import FeedbackIcon from '@icons/common/feedback.svg';
import { StyledFloatButton, StyledRate } from './styled';
import apptracker from '@utils/sensor/apptracker';
import useHideFeedback from './useHideFeedback';

const FeedbackForm = ({ onSubmit }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    // TODO: santize values?
    apptracker(USER_FEEDBACK, values);
    onSubmit();
  };

  return (
    <div style={{ width: 400 }}>
      <Form initialValues={{ comment: '' }} onFinish={onFinish} form={form} name="feeback-form">
        <Form.Item name="rate" rules={[{ required: true, message: 'Please select a rating' }]}>
          <StyledRate allowHalf />
        </Form.Item>

        <Form.Item
          name="comment"
          rules={[{ required: true, message: 'Please enter your feedback' }]}
        >
          <Input.TextArea showCount maxLength={150} />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

function Feedback() {
  const hideFeedback = useHideFeedback();

  const handleClick = () => {
    // Dispatch custom event to open contact drawer
    const event = new CustomEvent('openContactDrawer');
    window.dispatchEvent(event);
  };

  if (hideFeedback) {
    return null;
  }

  return (
    <Tooltip title="Contact Support" placement="left">
      <StyledFloatButton
        shape="circle"
        icon={<Icon component={FeedbackIcon} />}
        onClick={handleClick}
      />
    </Tooltip>
  );
}

export function FeedbackWidget({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  const handleOpenChange = (value: boolean) => {
    setOpen(value);
  };

  return (
    <Popover
      title="Share your feedback"
      content={<FeedbackForm onSubmit={onClose} />}
      trigger="click"
      onOpenChange={handleOpenChange}
      open={open}
      destroyOnHidden={true}
    >
      <Tooltip title="Feedback" placement="left">
        {children}
      </Tooltip>
    </Popover>
  );
}

export default Feedback;
